/* eslint-disable default-param-last */
import { INITIAL_GROUP_BY_OPTIONS } from '../../../utils/constant';
import {
  ACTIVE_ADVANCED_FILTERS,
  CERT_DETAILS_FILTER_CHANGE_TRIGGER,
  CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER,
  CLEAR_ALL_FILTERS,
  CLEAR_SMART_FILTERS,
  FETCH_SMART_FILTERS_META_SUCCESS,
  RESET_DYNAMIC_SORT_FILTER_DETAILS,
  SET_APPLIED_ROW_FILTERS,
  SET_APPLIED_SAVI_ACTION_KEYS,
  SET_CERT_FILTERS,
  SET_CERTS_ACTIONS_FILTER,
  SET_CLEAR_FILTERS_BTN_STATUS,
  SET_CLEAR_HIERARCHY_BTN_STATUS,
  SET_CLEAR_SEARCH_BTN_STATUS,
  SET_COLS_FILTERS,
  SET_DYNAMIC_SORT_FILTER_DETAILS,
  SET_GROUP_BY_OPTIONS,
  SET_IS_SMART_FILTER_APPLIED,
  SET_ROWS_FILTERS,
  SET_SMART_FILTER_ID,
} from '../types';

const INITIAL_STATE = {
  customFilters: {},
  certsFilters: null,
  groupByOptions: INITIAL_GROUP_BY_OPTIONS,
  rowsFilters: null,
  appliedRowFilters: [],
  appliedSaviActionKeys: [],
  colsFilters: null,
  advancedFilters: null,
  triggerClearBtnForFilters: false,
  triggerClearBtnForSearch: null,
  triggerClearBtnForHierarchy: null,
  isTriggeredFromSearchOrFilter: false,
  filterChangeCounter: 0,
  isSmartApplied: null,
  smartFilterId: '',
  smartFiltersMeta: {},
  clearSmartFilters: false,
  clearAllFilters: false,
  dynamicSortFilter: {
    sortDirection: null,
    sortByColumn: null,
  },
};

const viewControlsReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERTS_ACTIONS_FILTER:
      return {
        ...state,
        customFilters: {
          ...state.customFilters,
          actionfilter: action?.payload,
        },
      };

    case SET_CERT_FILTERS:
      return {
        ...state,
        certsFilters: action?.payload?.results,
      };

    case SET_GROUP_BY_OPTIONS:
      return {
        ...state,
        groupByOptions: action?.payload?.results,
      };

    case SET_ROWS_FILTERS:
      return {
        ...state,
        rowsFilters: action?.payload?.results,
      };

    case SET_APPLIED_ROW_FILTERS: {
      return {
        ...state,
        appliedRowFilters: action?.payload,
      };
    }

    case SET_APPLIED_SAVI_ACTION_KEYS:
      return {
        ...state,
        appliedSaviActionKeys: action?.payload || [],
      };

    case SET_COLS_FILTERS:
      return {
        ...state,
        colsFilters: action?.payload?.results,
      };

    case ACTIVE_ADVANCED_FILTERS:
      return {
        ...state,
        advancedFilters: action?.payload?.results,
      };

    case SET_CLEAR_FILTERS_BTN_STATUS:
      return {
        ...state,
        triggerClearBtnForFilters: action?.payload,
      };

    case SET_CLEAR_SEARCH_BTN_STATUS:
      return {
        ...state,
        triggerClearBtnForSearch: action?.payload,
      };

    case SET_CLEAR_HIERARCHY_BTN_STATUS:
      return {
        ...state,
        triggerClearBtnForHierarchy: action?.payload,
      };

    case CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER:
      return {
        ...state,
        isTriggeredFromSearchOrFilter: action?.payload,
      };

    case CERT_DETAILS_FILTER_CHANGE_TRIGGER:
      return {
        ...state,
        filterChangeCounter: state.filterChangeCounter + 1,
      };

    case SET_IS_SMART_FILTER_APPLIED:
      return {
        ...state,
        isSmartApplied: action?.payload,
      };

    case SET_SMART_FILTER_ID:
      return {
        ...state,
        smartFilterId: action?.payload,
      };

    case FETCH_SMART_FILTERS_META_SUCCESS:
      return {
        ...state,
        smartFiltersMeta: { ...action.payload },
      };

    case CLEAR_SMART_FILTERS:
      return {
        ...state,
        clearSmartFilters: action?.payload,
      };

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        clearAllFilters: action?.payload,
      };

    case SET_DYNAMIC_SORT_FILTER_DETAILS:
      return {
        ...state,
        dynamicSortFilter: {
          ...state.dynamicSortFilter,
          sortDirection: action.payload.sortDirection,
          sortByColumn: action.payload.columnName,
        },
      };

    case RESET_DYNAMIC_SORT_FILTER_DETAILS:
      return {
        ...state,
        dynamicSortFilter: {
          ...state.dynamicSortFilter,
          sortDirection: null,
          sortByColumn: null,
        },
      };

    default:
      return state;
  }
};

export default viewControlsReducer;
